export default __webpack_public_path__ + "static/media/kitchen5-beforeA-480w.07478239.webp";